export const SET_SIGNIN_NAV_HEADER = "SET_SIGNIN_NAV_HEADER";

// ID CARD DETECTION
export const UPDATE_IDCARD_DECTECT = "UPDATE_IDCARD_DECTECT";